import FetchFactory from '../factory';
const CONTROLLER_PATH = '/api-electra/ConfirmRetailOrder';

class ConfirmRetailOrderModule extends FetchFactory<any> {
  async confirmRetailOrder(orderGuid: string): Promise<boolean> {
    try {
      await this.post(
        `${CONTROLLER_PATH}/ConfirmRetailOrder?orderGuid=${orderGuid}`,
        {},
      );
      return true;
    } catch (e) {
      return false;
    }
  }
}

export default ConfirmRetailOrderModule;
